module.exports = __webpack_public_path__ + "c21cdaf5bc956036fbc607d0f941ef85.pdf";